/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Functions overview", description = "Transform, validate, or enrich events with custom JavaScript before they sync to a destination.", lastUpdatedDate = new Date(1782345600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Functions overview",
        description: "Transform, validate, or enrich events with custom JavaScript before they sync to a destination.",
        lastUpdatedDate: "Thu Jun 25 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: [{
          "value": "Features",
          "depth": 1,
          "id": "features"
        }, {
          "value": "Use cases",
          "depth": 1,
          "id": "use-cases"
        }, {
          "value": "Getting started",
          "depth": 1,
          "id": "getting-started"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      img: "img",
      h3: "h3",
      ul: "ul",
      li: "li",
      strong: "strong"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsxs(_components.p, {
        children: ["Functions let you transform events before they sync to a destination. Write JavaScript to modify event properties, validate fields, or enrich event data on any ", _jsx(_components.a, {
          href: "/events/overview",
          children: "Hightouch Events"
        }), " sync."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "events/functions/overview-graphic.png",
          alt: "Function overview graphic"
        })
      }), "\n", _jsx(_components.h3, {
        id: "features",
        children: "Features"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Modify, validate, enrich, or filter events with custom logic before they sync to destinations"
        }), "\n", _jsx(_components.li, {
          children: "Write transformations in modern JavaScript"
        }), "\n", _jsx(_components.li, {
          children: "Code, test, and connect functions to syncs within the Hightouch app"
        }), "\n", _jsx(_components.li, {
          children: "Transform batches of events at once"
        }), "\n"]
      }), "\n", _jsx(_components.h3, {
        id: "use-cases",
        children: "Use cases"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Enrich event data."
          }), " Call external APIs to add data to your event payload. For example, add geolocation fields based on IP addresses."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Data cleaning and normalization."
          }), " Encrypt sensitive information, normalize complicated data types, or remove PII from event payloads."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Data validation."
          }), " Write advanced validation logic so your event data conforms to your spec."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "General transformations."
          }), " Reshape an event before sending it to a destination."]
        }), "\n"]
      }), "\n", _jsx(_components.h3, {
        id: "getting-started",
        children: "Getting started"
      }), "\n", _jsxs(_components.p, {
        children: ["Use functions to transform events in any event sync: create a function, test the code, and connect it to a sync. ", _jsx(_components.a, {
          href: "/events/functions/getting-started",
          children: "Read the guide"
        }), " to get started."]
      })]
    });
  }
}
export default MDXContent;
